import { isEqual } from "lodash-es";

export function objectDirtyChecker(oldValue: unknown, newValue: unknown) {
  return !isEqual(oldValue, newValue);
}
